module.exports = __webpack_public_path__ + "static/media/plan-TH3-desktop-sc.fcf6173c.png";